export const HIDE_METADATA = {
	scope: "server",
} as const;
